import * as Sentry from "@sentry/vue";

Sentry.init({
  release: window.marque.ui.version,
  environment: window.marque.ui.environment,
  dsn: window.marque.ui.sentryDSN,
  tracesSampleRate: window.marque.ui.sentryTraceSampleRate,
  ignoreErrors: [
      "AxiosError: Request failed with status code 403",
      "Non-Error promise rejection captured with value: undefined",
      "Request failed with status code 401",
      "Avoided redundant navigation to current location",
      "timeout of 0ms exceeded",
      "Network Error",
      "undefined is not an object (evaluating 'c.matched')",
      "The index is not in the allowed range",
      "AxiosError: Request aborted",
      'Could not load "util".'
  ],
  integrations: [Sentry.browserTracingIntegration()],
})

Sentry.configureScope((scope) => {
  scope.setUser({
    'id': window.marque.ui.user.id, 
    'name':  window.marque.ui.user.name, 
    'email':  window.marque.ui.user.email
  });
  
  scope.setTag('account_id', window.marque.ui.account.id);
  scope.setTag('account_name', window.marque.ui.account.name);
});

window.Sentry = Sentry;